import Match from 'app/components/tv/models/Match';
import {Image} from 'app/components/tv/models/common';

export interface IVideo {
  id: number;
  slug: string;
  category: string;
  user: null;
  title: string;
  matchPlaylist: string;
  matchPlaylistId: number;
  source: string;
  startSec: number | null;
  duration: number;
  dateCreated: string;
  thumbnail: Image;
  minute: number;
  additionalMinute: number;
  homeGoal: number | null;
  guestGoal: number | null;
  actionType: string;
  muted: false;
  match: Match;
  sources: {type: string; src: string}[];
  poster: string;
  get startTime(): number;
  get videoDuration(): number | null;
  isSeekable(): boolean;
  showFuPaTvLogo(): boolean;
}

export default abstract class Video implements IVideo {
  readonly id: number;
  readonly slug: string;
  readonly category: string;
  readonly user: null;
  readonly title: string;
  readonly matchPlaylist: string;
  readonly matchPlaylistId: number;
  readonly source: string;
  readonly startSec: number | null;
  readonly duration: number;
  readonly dateCreated: string;
  readonly thumbnail: Image;
  readonly minute: number;
  readonly additionalMinute: number;
  readonly homeGoal: number | null;
  readonly guestGoal: number | null;
  readonly actionType: string;
  readonly muted: false;
  readonly match: Match;
  readonly sources: {type: string; src: string}[];
  readonly poster: string;

  constructor(data: IVideo) {
    Object.assign(this, data);
    const sourceType = this.source?.endsWith('m3u8') ? 'application/x-mpegURL' : 'video/mp4';
    this.sources = [{type: sourceType, src: this.source}];
    this.poster = this.thumbnail ? `${this.thumbnail.path}1440x810.jpeg` : '';
  }

  abstract get startTime(): number;
  abstract get videoDuration(): number | null;
  abstract isSeekable(): boolean;
  abstract showFuPaTvLogo(): boolean;
}
